import { memo } from 'react';
import { RoundedCard } from '../RoundedCard/RoundedCard';
import { Icon, Text } from '../../components';
import logo from '../../assets/images/logo.png';
import {
  scrollToElement,
  WHO_WE_ARE_ID,
  ABOUT_US_ID,
  ONLINE_BUSINESS_CONSULTING_ID,
  GET_IN_TOUCH_FORM_ID
} from '../../utils';
import "./Footer.scss";

function MemoComponent() {
  const items = [
    { label: "Who we are", link: WHO_WE_ARE_ID },
    { label: "About us", link: ABOUT_US_ID },
    { label: "Services", link: ONLINE_BUSINESS_CONSULTING_ID },
    { label: "Contact", link: GET_IN_TOUCH_FORM_ID },
  ];

  return (
    <footer className="footer bg-footer-image">
      <div className="footer-content">
        <RoundedCard>
          <img src={logo} alt="logo" className="display-block logo mb-30"/>

          <div className="display-flex flex-wrap space-between gap-30 align-items-center mb-30 first-row">
            <Text variant="content3" color="tertiary" className="motto">
              Empowering your growth through expert online business consulting
            </Text>

            <div className="display-flex flex-wrap align-items-center gap-30 links-container">
              {items.map((item) => (
                <Text
                  key={item.label}
                  variant="content2"
                  color="tertiary"
                  className="as-link link"
                  onClick={() => scrollToElement(item.link)}
                >
                  {item.label}
                </Text>
              ))}
            </div>
          </div>

          <div className="display-flex flex-wrap space-between gap-30 align-items-center second-row">
            <div className="display-flex align-items-center gap-10">
              <Icon className="icon-heart" size={24}/>
              <Text variant="content2" color="tertiary">Powered by RealGrowSoft</Text>
            </div>

            <Text variant="content2" color="tertiary">
              Albatross HK - Flat 2A1-A7, Pahsang Industrial Bldg. 16 Sun On street, Tuen Mun, N.T. Hong Kong
            </Text>

          </div>
        </RoundedCard>
      </div>
    </footer>
  )
}

export const Footer = memo(MemoComponent);